<script setup lang="ts">
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { type Color, getColorValue } from '@global-types/colors';
import { useIconCache } from '@composables/useIconCache';

interface IconProps {
  name: string;
  title?: string;
  width?: string | number;
  height?: string | number;
  fill?: Color | 'current';
}

const props = defineProps<IconProps>();

const colorValue = computed<string | undefined>(() => {
  if (props.fill === undefined) {
    return undefined;
  }

  if (props.fill === 'current') {
    return 'currentColor';
  }

  return getColorValue(props.fill);
});

const { svgUrl } = useIconCache(props.name);
</script>

<template>
  <InlineSvg
    v-if="svgUrl"
    :src="svgUrl"
    :title="title"
    :width="width"
    :height="height"
    :fill="colorValue"
  />
</template>
